import { PlayArrowRounded } from "@mui/icons-material";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { resolveVideoPreview } from "../../../network/cloudflare_stream_service/CloudflareStream_api_callback";
import { extractVimeoId, getVimeoPlayLink } from "../../../network/vimeo_network_service/Vimeo_api_callback";

const MultimediaItem = ({ item, isActive, isSelected, onPlay, onClick }) => {
    const id = item?._id;
    const title = item?.title;
    const image = item?.image;
    const duration = item?.duration;
    const theme = item?.theme;
    const videoUrl = item?.videoUrl;
    const timeLine = item?.timeLine;
    const preview = resolveVideoPreview({
        form: 'video',
        url: videoUrl,
        cloudFlareVideoId: item?.cloudFlareVideoId,
        previewUrl: item?.previewUrl,
    });
    const vimeoId = extractVimeoId(videoUrl);
    const [videoSrc, setVideoSrc] = useState(null);

    // Fetch video only when this card becomes active
    useEffect(() => {
        const loadVideo = async () => {
            if (!isActive) {
                setVideoSrc(null);
                return;
            }
            if (preview.type === 'cloudflare') {
                setVideoSrc(preview.embedUrl);
                return;
            }
            try {
                const { progressiveLink, playLink } = await getVimeoPlayLink(vimeoId);
                setVideoSrc(progressiveLink || playLink);
            } catch (err) {
                console.error("❌ Error fetching Vimeo link:", err);
            }
        };
        loadVideo();
    }, [isActive, videoUrl, preview.type, preview.embedUrl, vimeoId]);

    return (
        <Grid item key={id}>
            <Box
                sx={{
                    position: "relative",
                    height: 250,
                    width: 300,
                    borderRadius: 2,
                    overflow: "hidden",
                    backgroundColor: "whitesmoke",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    border: isSelected ? "1px solid #1976d2" : "1px solid #ddd", // 🔹 highlight
                    boxShadow: isSelected ? 4 : 1, // 🔹 stronger shadow if selected
                    transition: "all 0.2s ease-in-out",
                    cursor: "pointer",
                }}
            >
                {/* Thumbnail OR Vimeo Player */}
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        height: 160,
                        backgroundImage: !isActive
                            ? `url(${image || ""})`
                            : "none",
                        backgroundSize: "cover",
                        bgcolor: "rgba(0,0,0,0.6)",
                        backgroundPosition: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {/* Overlay gradient */}
                    {/* <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.1))",
                        }}
                    /> */}

                    {/* Play button */}
                    {/* <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                        }}
                    >
                        <PlayCircleOutline sx={{ fontSize: 50, opacity: 0.9 }} />
                    </Box> */}

                    {!isActive ? (
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation(); // prevent triggering onClick selection
                                onPlay();
                            }}
                            sx={{
                                bgcolor: "rgba(0,0,0,0.6)",
                                color: "white",
                                "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
                                p: 3,
                            }}
                        >
                            <PlayArrowRounded fontSize="large" />
                        </IconButton>
                    ) : (
                        // <Vimeo
                        //     video={playableVimeoVideoUrl?.uri?.replace("/videos/", "")}
                        //     autoplay
                        //     responsive
                        //     controls = {true}
                        //     playsInline
                        //     style={{ width: "100%", height: "100%" }}
                        //     options={{
                        //         title: true,      // hides video title
                        //         byline: true,     // hides "by username"
                        //         portrait: false,   // hides profile image
                        //         autopause: true,   // stop other videos when this plays
                        //         transparent: false,// keep player background solid
                        //         dnt: false,         // do not track viewer
                        //         controls: false,    // show/hide playbar
                        //         keyboard: false,   // disable keyboard shortcuts
                        //         pip: false,        // disable Picture-in-Picture
                        //         autoplay: false,    // force autoplay (if allowed by browser)
                        //         loop: false,       // disable looping
                        //         muted: false       // start unmuted
                        //     }}
                        // />
                        videoSrc && (
                            preview.type === 'cloudflare' ? (
                                <iframe
                                    title={`cf-${id}`}
                                    src={videoSrc}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        border: 0,
                                        borderRadius: 2,
                                        backgroundColor: "black",
                                    }}
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    frameBorder="0"
                                />
                            ) : (
                                <video
                                    src={videoSrc}
                                    controls
                                    autoPlay
                                    playsInline
                                    controlsList="nodownload"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 2,
                                        backgroundColor: "black",
                                    }}
                                    onPause={() => console.log("paused")}
                                />
                            )
                        )
                    )}
                </Box>

                {/* Info area */}
                <Box sx={{ p: 1 }} onClick={() => {
                    console.log("clicked!!!")
                    onClick();
                }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 13 }}>{title || "Untitled Video"}</Typography>

                    <Typography variant="caption" color="text.secondary">Duration : {duration || "N/A"} sec</Typography>

                    <Typography sx={{ fontWeight: 550, fontSize: 10 }}>
                        {preview.type === 'cloudflare'
                            ? `Cloudflare ID : ${preview.id || "_"}`
                            : `Vimeo ID : ${vimeoId || "_"}`}
                    </Typography>

                    <Typography sx={{ fontWeight: 550, fontSize: 10 }}>Video ID : {id || "_"}</Typography>

                </Box>

                {/* Action buttons */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        display: "flex",
                        gap: 0.5,
                    }}
                >
                    {/* <IconButton size="small" sx={{ bgcolor: "white" }} onClick={() => {

                    }}>
                        <EditTwoTone fontSize="small" />
                    </IconButton> */}
                    {/* <IconButton size="small" sx={{ bgcolor: "white" }}>
                        <CloseRounded fontSize="small" />
                    </IconButton> */}
                </Box>
            </Box>
        </Grid>
    );
};

export default MultimediaItem;
